export type Holiday = {
  name: string
  longName: string
  color: string
}

export const HOLIDAYS: { [key: string]: Holiday } = {
  '04-13': { name: 'Palm', longName: 'Palm Sunday', color: '#A9CB54' },
  '04-18': { name: 'Good', longName: 'Good Friday', color: '#4DA0CC' },
  '04-20': { name: 'Easter', longName: 'Easter', color: '#B57FDE' },
}
